import AssetsTable from './AssetsTable'
export default AssetsTable
